<div class="talonario-title-wrapper">
  <app-title-header [title]="_title" [subtitle]="_subtitle" class="d-xl-block d-none">
  </app-title-header>

  <span class="talonario-info-tooltip" data-toggle="tooltip" data-placement="right"
    title="En esta sección podrás crear documentos médicos digitales de forma rápida, simple y segura, sin necesidad de realizar una videoconsulta.">
    <i class="fi fi-rr-info"></i>
  </span>
</div>

<ng-container *ngIf="canUseDigitalPad; else sinPermisoTalonario">
  <div class="talonario-container">

    <div class="section-header">
      <div>
        <h2>¿Qué documento quieres generar?</h2>
        <p>Selecciona el tipo de documento clínico que necesitas emitir.</p>
      </div>
    </div>

    <div class="documents-grid">

      <div class="document-card" *ngFor="let document of filteredDocuments">

        <div class="document-top">
          <div class="document-icon">
            <i [ngClass]="document.icon" style="display: flex; justify-content: center;"></i>
          </div>


        </div>

        <h3>{{ document.title }}</h3>

        <p>{{ document.description }}</p>

        <button type="button" class="btn document-btn" (click)="openDocument(document)">
          {{ document.buttonText }}
        </button>

      </div>

    </div>

    <div class="documentos-generados mt-4">

      <div class="header-documentos d-flex justify-content-between align-items-center mb-2">
        <div class="d-flex align-items-center">
          <i class="fi fi-rr-assept-document mr-2" style="display: flex; justify-content: center;">
          </i>

          <span class="titulo-header">Mis documentos generados</span>
        </div>

        <button type="button" class="btn-filtros" [ngClass]="{ 'btn-filtros-activo': hasFiltrosActivos() }"
          (click)="toggleFiltros()">
          <i class="fi fi-rr-filter mr-1"></i>
          Filtros
        </button>
      </div>

      <hr class="mt-0 mb-2">

      <div *ngIf="mostrarFiltros" class="filtros-overlay" (click)="cerrarFiltros()">

        <div class="dropdown-filtros" (click)="$event.stopPropagation()">

          <div class="filtros-header">
            <span>Filtros</span>

            <button type="button" class="btn-filtros" [ngClass]="{ 'btn-filtros-activo': hasFiltrosActivos() }"
              (click)="toggleFiltros()">
              <i class="fi fi-rr-filter mr-1"></i>
              Filtros
            </button>
          </div>

          <hr class="filtro-separator">

          <div class="filtro-section">
            <div class="filtro-label">Buscar por nombre</div>

            <input type="text" class="form-control filtro-input" placeholder="Nombre del paciente"
              [(ngModel)]="filtrosGenerados.nombre" (keyup)="filtrarDocumentosGenerados()">
          </div>

          <hr class="filtro-separator">

          <div class="filtro-section">
            <div class="filtro-label">Rango de fechas</div>

            <input type="date" class="form-control filtro-input mb-2" [(ngModel)]="filtrosGenerados.fechaDesde"
              (change)="filtrarDocumentosGenerados()">

            <input type="date" class="form-control filtro-input" [(ngModel)]="filtrosGenerados.fechaHasta"
              (change)="filtrarDocumentosGenerados()">
          </div>

          <hr class="filtro-separator">

          <div class="filtro-section">
            <div class="filtro-label">Tipo de documento</div>

            <div class="form-check mb-1" *ngFor="let tipo of tiposDocumentosGenerados; let i = index">

              <input class="form-check-input" type="checkbox" [id]="'chkDocGenTipo' + i"
                [checked]="isTipoGeneradoSelected(tipo)" (change)="toggleTipoGenerado(tipo, $event.target.checked)">

              <label class="form-check-label" [for]="'chkDocGenTipo' + i">
                {{ tipo }}
              </label>
            </div>
          </div>

          <div class="filtro-actions mt-2">
            <button type="button" class="btn-limpiar mr-2" (click)="limpiarFiltrosGenerados()">
              Limpiar
            </button>

            <button type="button" class="btn-aplicar" (click)="cerrarFiltros()">
              Cerrar
            </button>
          </div>

        </div>
      </div>
      <div *ngIf="loadingDocumentosGenerados" class="text-center p-3">
        Cargando documentos...
      </div>
      <div class="table-responsive" *ngIf="!loadingDocumentosGenerados">
        <table class="table table-sm custom-table m-0">

          <thead class="tabla-docs">
            <tr>
              <th>Nombre paciente</th>
              <th class="d-none d-md-table-cell">Fecha</th>
              <th>Origen</th>
              <th class="text-right"></th>
            </tr>
          </thead>

          <tbody *ngIf="documentosGeneradosPaginados.length > 0">
            <tr *ngFor="let doc of documentosGeneradosPaginados; let i = index">
              <td>
                <div class="d-flex align-items-center">
                  <div class="doc-icon-table">
                    <i [ngClass]="getIconoDocumentoGenerado(doc.tipo)" style="display: flex; justify-content: center;">
                    </i>
                  </div>

                  <div class="nombre-doc ml-2">
                    <div class="nombre-principal mb-1">
                      {{ doc.nombre }}
                    </div>

                    <div class="nombre-secundario">
  {{ doc.tipo | uppercase }}
  <ng-container *ngIf="doc.subtipo && doc.subtipo !== 'NULO'">
    -{{ doc.subtipo }}
  </ng-container>
</div>

                    <div class="fecha-mobile d-block d-md-none text-muted">
                      {{ doc.fechaTexto }}
                    </div>
                  </div>
                </div>
              </td>

              <td class="align-middle d-none d-md-table-cell">
                {{ doc.fechaTexto }}
              </td>

              <td class="align-middle">
                {{ doc.origen | titlecase  }}
              </td>

              <td class="text-right align-middle">
                <i *ngIf="doc.att_id" class="fi fi-rr-download" title="Descargar documento"
                  (click)="descargarDocumentoGenerado(doc)" style="cursor: pointer;">
                </i>

                <span *ngIf="!doc.att_id" class="text-muted">
                  —
                </span>
              </td>

            </tr>
          </tbody>

          <tbody *ngIf="documentosGeneradosFiltrados.length === 0">
            <tr>
              <td colspan="4" class="text-center p-3">
                No existen documentos generados.
              </td>
            </tr>
          </tbody>

        </table>
        <div class="paginador-documentos d-flex flex-column flex-md-row justify-content-between align-items-center mt-3"
          *ngIf="documentosGeneradosFiltrados.length > 0">

          <div class="paginador-info mb-2 mb-md-0">
            Mostrando
            <strong>{{ getDesdeRegistro() }}</strong>
            -
            <strong>{{ getHastaRegistro() }}</strong>
            de
            <strong>{{ documentosGeneradosFiltrados.length }}</strong>
            documentos
          </div>

          <div class="d-flex align-items-center mb-2 mb-md-0">

            <span class="mr-2 paginador-label">
              Mostrar
            </span>

            <select class="form-control form-control-sm paginador-select" [(ngModel)]="itemsPorPagina"
              (change)="cambiarItemsPorPagina($event.target.value)">

              <option *ngFor="let opcion of opcionesItemsPorPagina" [value]="opcion">
                {{ opcion }}
              </option>

            </select>

            <span class="ml-2 paginador-label">
              por página
            </span>

          </div>

          <div class="paginador-botones d-flex align-items-center">

            <button type="button" class="btn-paginador" [disabled]="paginaActual === 1" (click)="irPaginaAnterior()">

              <i class="fi fi-rr-angle-small-left"></i>
            </button>

            <button type="button" class="btn-paginador btn-numero" *ngFor="let pagina of getPaginasVisibles()"
              [ngClass]="{ 'btn-paginador-activo': paginaActual === pagina }" (click)="irPagina(pagina)">

              {{ pagina }}
            </button>

            <button type="button" class="btn-paginador" [disabled]="paginaActual === totalPaginas"
              (click)="irPaginaSiguiente()">

              <i class="fi fi-rr-angle-small-right"></i>
            </button>

          </div>

        </div>
      </div>

    </div>

  </div>

</ng-container>

<ng-template #sinPermisoTalonario>
  <div class="talonario-container">
    <div class="alert alert-warning mt-3">
      No tienes permisos para acceder al talonario digital.
    </div>
  </div>
</ng-template>